import SvgColor from '../../../components/svg-color';
import { PERMISSIONS } from '../../../protectedRoute';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

// `permission`: el item solo se muestra si el empleado logueado tiene ese
// permiso (los admins ven todo). NavSection filtra con hasPermission().
const navConfig = [
  {
    subheader: 'Management',
    items: [
      {
        title: 'Users',
        path: '/dashboard/user',
        icon: icon('ic_user'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Employees',
        path: '/dashboard/employees',
        icon: icon('ic_user'),
        permission: PERMISSIONS.VIEW_EMPLOYEES,
      },
      {
        title: 'News',
        path: '/dashboard/events',
        icon: icon('ic_blog'),
        permission: PERMISSIONS.VIEW_EVENTS,
      },
      {
        title: 'Push Notifications',
        path: '/dashboard/push-notifications',
        icon: icon('ic_notification'),
        permission: PERMISSIONS.VIEW_EVENTS,
      },
    ],
  },
  {
    subheader: 'Membresías',
    items: [
      {
        title: 'Membresías',
        path: '/dashboard/memberships',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Solicitudes',
        path: '/dashboard/membership-requests',
        icon: icon('ic_reports'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Layaways',
        path: '/dashboard/layaways',
        icon: icon('ic_tag'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Pagos de layaway',
        path: '/dashboard/layaways/payments',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Lista de espera',
        path: '/dashboard/waitlist',
        icon: icon('ic_notification'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Transferencias FFL',
        path: '/dashboard/transfers',
        icon: icon('ic_tag'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Armerías FFL',
        path: '/dashboard/ffl-dealers',
        icon: icon('ic_categories'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
      {
        title: 'Pedidos y servicios',
        path: '/dashboard/service-orders',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_MEMBERS,
      },
    ],
  },
  {
    subheader: 'Reservations',
    items: [
      {
        title: 'Reservations',
        path: '/dashboard/reservations',
        icon: icon('ic_calendar'),
        permission: PERMISSIONS.VIEW_CALENDAR,
      },
      {
        title: 'Recientes',
        path: '/dashboard/reservations/activity',
        icon: icon('ic_reports'),
        permission: PERMISSIONS.VIEW_CALENDAR,
      },
      {
        title: 'Pagos',
        path: '/dashboard/reservations?view=payments',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_PAYMENTS,
      },
      {
        title: 'Aliados',
        path: '/dashboard/partners',
        icon: icon('ic_user'),
        permission: PERMISSIONS.VIEW_PAYMENTS,
      },
      {
        title: 'Pago a instructores',
        path: '/dashboard/instructor-pay',
        icon: icon('ic_reports'),
        permission: PERMISSIONS.VIEW_INSTRUCTOR_PAY,
      },
      {
        title: 'Vendedores CSCC',
        path: '/dashboard/cscc-vendors',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_CSCC_VENDORS,
      },
      {
        title: 'Sorteos',
        path: '/dashboard/raffles',
        icon: icon('ic_cart'),
        permission: PERMISSIONS.VIEW_RAFFLES,
      },
      {
        title: 'Registro del Range',
        path: '/dashboard/reports',
        icon: icon('ic_reports'),
        permission: PERMISSIONS.VIEW_CALENDAR,
      },
      {
        title: 'Categories',
        path: '/dashboard/reservation-categories',
        icon: icon('ic_categories'),
        permission: PERMISSIONS.VIEW_CATEGORIES,
      },
      {
        title: 'Cursos',
        path: '/dashboard/courses',
        icon: icon('ic_categories'),
        permission: PERMISSIONS.VIEW_CALENDAR,
      },
      {
        title: 'Lanes',
        path: '/dashboard/lanes',
        icon: icon('ic_tag'),
        permission: PERMISSIONS.VIEW_CATEGORIES,
      },
      {
        title: 'Cupones',
        path: '/dashboard/coupons',
        icon: icon('ic_tag'),
        permission: PERMISSIONS.VIEW_CATEGORIES,
      },
      {
        title: 'Bloqueos',
        path: '/dashboard/lane-blocks',
        icon: icon('ic_tag'),
        permission: PERMISSIONS.EDIT_CALENDAR,
      },
      {
        title: 'Recurring',
        path: '/dashboard/recurring-reservations',
        icon: icon('ic_calendar'),
        permission: PERMISSIONS.EDIT_CALENDAR,
      },
      {
        title: 'Availability',
        path: '/dashboard/availability',
        icon: icon('ic_gear'),
        permission: PERMISSIONS.EDIT_CALENDAR,
      },
    ],
  },
  {
    subheader: 'Settings',
    items: [
      {
        title: 'Configuration',
        path: '/dashboard/configuration',
        icon: icon('ic_gear'),
        permission: PERMISSIONS.VIEW_CONFIG,
      },
      {
        title: 'Email Notifications',
        path: '/dashboard/email-notifications',
        icon: icon('ic_notification'),
        permission: PERMISSIONS.VIEW_CONFIG,
      },
    ],
  },
];

export default navConfig;
